var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenchmarking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.001,
    height: 17.815,
    viewBox: "0 0 19.001 17.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28849",
    "data-name": "Group 28849",
    transform: "translate(-123.601 -3.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8901",
    "data-name": "Rectangle 8901",
    transform: "translate(123.601 12.364)",
    fill: "none",
    stroke: "#9d9fab",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 8.908,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 3.5,
    height: 7.408,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8902",
    "data-name": "Rectangle 8902",
    transform: "translate(130.601 3.456)",
    fill: "none",
    stroke: "#9d9fab",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 17.814,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 3.5,
    height: 16.314,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8903",
    "data-name": "Rectangle 8903",
    transform: "translate(137.601 7.205)",
    fill: "none",
    stroke: "#9d9fab",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 14.065,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 3.5,
    height: 12.565,
    rx: 1.25,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarking);
export default __webpack_public_path__ + "static/media/Benchmarking.55a29b20c6c8da4ed3699e3dac9f7318.svg";
export { ForwardRef as ReactComponent };